import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

type AccountId = string;

export type UserPropertyResponse = {
	key: string;
	value: boolean;
};

export const getHasDismissedReleaseAutomationBanner = async (
	accountId: AccountId,
): Promise<boolean> => {
	const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
	const fetchResponse: Response = await fetch(url, getDefaultOptions(url));

	// ok is true only when status code is 2xx.
	if (fetchResponse.ok) {
		const responseObj: UserPropertyResponse = await fetchResponse.json();
		return responseObj.value;
	}

	const { status } = fetchResponse;

	// 401: If credential is incorrect, the user is not authorised and should not see the banner
	if (status === 401) {
		return true;
	}

	// 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the banner
	if (status === 404) {
		return false;
	}

	throw new Error(
		`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`,
	);
};

export const dismissReleaseAutomationBanner = async (accountId: AccountId): Promise<void> => {
	const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
	const fetchResponse: Response = await fetch(url, {
		...getDefaultOptions(url),
		method: 'PUT',
		body: JSON.stringify(true),
	});
	if (!fetchResponse.ok) {
		throw Error('Failed to dismiss release automation banner via user properties.');
	}
};

export const fireReleaseAutomationBannerError = (error: Error): Promise<void> =>
	fireErrorAnalytics({
		meta: {
			id: 'versions.release.version.modal.release.automation.user.property',
			packageName: 'jiraVersionModals',
			teamName: 'jolt',
		},
		error,
		sendToPrivacyUnsafeSplunk: true,
	});
